<template>
  <div
    v-if="show"
    :style="{ height: h + 'px', width: w + 'px' }"
    class="_view_container"
  >
    <div class="_view_container_inner">
      <div
        role="button"
        class="viewer-button viewer-close"
        data-viewer-action="mix"
      ></div>
      <div class="_view_container_mask" @click="closeBox"></div>
      <div class="_view_container_body">
        <div
          v-if="imgs.length > 0"
          ref="_iview_content"
          class="_iview_content"
          @click="continerClick"
        >
          <el-carousel
            ref="carousel"
            arrow="always"
            :loop="loop"
            :indicator-position="'none'"
            style="height: 100%;width: 100%"
            height="100%"
          >
            <el-carousel-item
              v-for="(item, index) in imgs"
              :key="index"
              style="height: 100%;width: 100%;"
            >
              <img
                style="max-width: 100%;max-height: 100%;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
                :src="item"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loop: false,
      always: true,
      h: 0,
      w: 0,
      middle_point: 0, //中线
    };
  },
  mounted() {
    this.h = document.body.offsetHeight;
    this.w = document.body.offsetWidth;
  },
  methods: {
    closeBox() {
      this.$emit("closeBox");
    },
    // 点击图片左右切换显示
    continerClick(e) {
      let middle_point = this.$refs._iview_content.offsetWidth / 2;
      if (e.offsetX > middle_point) {
        // 往右
        this.$refs.carousel.next();
      } else {
        //往左
        this.$refs.carousel.prev();
      }
    },
  },
};
</script>

<style scoped>
body {
  position: relative;
}
._view_container {
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10000;
}
._view_container_inner {
  width: 100%;
  height: 100%;
  position: relative;
}
._view_container_mask {
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.2;
}
._view_container_body {
  z-index: 10000000;
  width: 50%;
  height: 70%;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
._iview_content {
  width: 100%;
  height: 100%;
}
.el-carousel {
  width: 100% !important;
  height: 100% !important;
}
.el-carousel .el-carousel__container {
  width: 100% !important;
  height: 100% !important;
}
.carousel__indicators {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewImage.vue